import { ReportWebService, RestfulReportWebService } from 'ws/ReportWebService';

import {
  ReportType,
  ReportDimension,
  ReportGran,
  ReportData,
} from './ReportData';

export interface ReportManager {
  getReportData(
    type: ReportType,
    dimension: ReportDimension,
    gran: ReportGran,
    filter: any,
    from: string,
    to: string,
  ): Promise<ReportData>;
  downloadTenmaxReconciliationReport(from: string, to: string): Promise<void>;
}

export class DefaultReportManager implements ReportManager {
  webService: ReportWebService;

  constructor(webService: ReportWebService = new RestfulReportWebService()) {
    this.webService = webService;
  }
  async getReportData(
    type: ReportType,
    dimension: ReportDimension,
    gran: ReportGran,
    filter: any,
    from: string,
    to: string,
  ) {
    return this.webService.getReportData(
      type,
      dimension,
      gran,
      filter,
      from,
      to,
    );
  }
  async downloadTenmaxReconciliationReport(
    from: string,
    to: string,
  ): Promise<void> {
    await this.webService.downloadTenmaxReconciliationReport(from, to);
  }
}
